import { Navigate } from 'react-router-dom';
import {detectPathUrl} from "helpers/detectPathUrl";

const Main = () => {
    return <Navigate to={detectPathUrl('app')} />;
};

export default Main;